import { getUri } from 'services/generic';
import { BreadcrumbType } from 'types/ProductListing/ProductListing';

export function getBreadcrumbWithLocale(
  breadcrumb: BreadcrumbType[]
): BreadcrumbType[] {
  return breadcrumb.map(item => ({
    ...item,
    url: getUri(item.url),
  }));
}
